import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { EPrijemnicaStavka } from './eprijemnica-stavka';

@Component({
  selector: 'yt-eprijemnica-stavka-modal-update',
  templateUrl: './eprijemnica-stavka-modal-update.component.html'
})
export class EPrijemnicaStavkaModalUpdateComponent
 extends BaseModalUpdateComponent<EPrijemnicaStavka> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<EPrijemnicaStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  izlazna: boolean = false;

      ngOnInit() {
        super.ngOnInit();
        //   this.izlazna=this.modelData.MainTitle==='Izlazna otpremnica';
      }
}
